import styled,{css} from "styled-components";

export const Contenido = styled.div`

  font-size: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  

  /*===========================================================
      VARIABLES GLOGABLES
  ===========================================================*/

  --elemento-border: #888888 0.01rem solid;
  --cabecera-elemento-font-size: 1rem;
  --cabecera-elemento-color: #525252;
  --cabecera-elemento-background-color: transparent;
  --contenido-elemento-font-size: 1rem;
  --contenido-elemento-font-weight: 400;
  --contenido-elemento-font-family: 'Courier New', Courier, monospace;

  /*===========================================================
      FIN VARIABLES GLOGABLES
  ===========================================================*/
  .tituloformtemplate {
    width: 100%;
    background-color: #ad6726;  /*#d8a808;*/
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(255, 255, 255);
    font-weight: 700;
    font-size: 1rem;
    border-radius: 1rem 1rem 0 0;
  }

  .formulariotemplate {
    background-color: rgb(238, 238, 238);
    border-radius: 0.2rem;
    width: 100%;
    // box-shadow: rgb(170, 170, 170) 0.1rem 0.1rem 1rem;
  }

  .formulariotemplate > .elementostemplate {
    padding: 1rem;
    box-sizing: border-box;
    // width: 40rem;
    display: grid;
    grid-template-columns: repeat(2,1fr);
  }

  .formulariotemplate > .elementostemplate > div {
    //background-color: green;
  }
  /*
  ===========================================================
      OPCIONES
  ===========================================================
  */
  .formulariotemplate > .opcionestemplate {
    background-color: #ad6726; /* rgb(216, 168, 8);*/
    padding: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
    height: auto;
    border-radius: 0 0 1rem 1rem;
  }

  
  /*
  ===========================================================
      INPUT
  ===========================================================
  */
  .formulariotemplate > .elementostemplate > .InputForm,
  .formulariotemplate > .elementostemplate > .CheckboxForm,
  .formulariotemplate > .elementostemplate > .RadiobuttonForm,
  .formulariotemplate > .elementostemplate > .OptionForm,
  .formulariotemplate > .elementostemplate > .DateForm {
    padding: 0.2rem;
    //background-color:rgb(64, 196, 32);
  }
  .formulariotemplate > .elementostemplate > .InputForm > input {
    width: 100%;
    box-sizing: border-box;
    height: 3.2rem;
    font-size: 1rem;
    font-weight: var(--contenido-elemento-font-weight);
    outline: none;
    border: var(--elemento-border);
    border-radius: 0.35rem;
    padding-top: 1.2rem;
    padding-left: 0.5rem;
  }
  .formulariotemplate > .elementostemplate > .InputForm > input:focus {
    ${props => (!props.$escomputadora && css`border: green 0.1rem solid;`)}
    box-shadow:0 0 0.2rem green inset;
  }
  .formulariotemplate > .elementostemplate > .InputForm {
    position: relative;
  }
  .formulariotemplate > .elementostemplate > .InputForm > label {
    background-color: var(--cabecera-elemento-background-color);
    position: absolute;
    left: ${props => (props.$escomputadora ? "0.7rem" : "1rem")};
    font-size: var(--cabecera-elemento-font-size);
    color: var(--cabecera-elemento-color);
  }

  /*
  ===========================================================
      CHECKBOX
  ===========================================================
  */
  .formulariotemplate > .elementostemplate > .CheckboxForm > label > input {
    width: 0.8rem;
  }
  .formulariotemplate > .elementostemplate > .CheckboxForm > div {
    background-color: white;
    height: 3.2rem;
    box-sizing: border-box;
    border-radius: 0.35rem;
    align-items: center;
    justify-content: center;
    border: var(--elemento-border);
  }

  .formulariotemplate > .elementostemplate > .CheckboxForm > div > label {
    display: block;
    background-color: var(--cabecera-elemento-background-color);
    font-size: var(--cabecera-elemento-font-size);
    color: var(--cabecera-elemento-color);
    padding-left: 0.7rem;
  }

  .formulariotemplate > .elementostemplate > .CheckboxForm > div > label > input[type="checkbox"] {
    display: none;
  }
  .formulariotemplate > .elementostemplate > .CheckboxForm > div > label > input[type="checkbox"] + span {
    font-size: 1rem;
    display: flex;
    align-items: center;
    margin-left: 1rem;
  }
  .formulariotemplate > .elementostemplate > .CheckboxForm > div > label > input[type="checkbox"] + span:before {
    content: "";
    width:  1.3rem;
    height: 1.3rem;
    background-color: #ffffff;
    display: flex;
    border: 0.1rem solid rgb(173, 173, 173);
    margin-top: 0.1rem;
    box-sizing: border-box;
  }

  .formulariotemplate > .elementostemplate > .CheckboxForm > div > label > input[type="checkbox"]:checked + span::after {
    content: "";
    border: var(--elemento-border);
    margin-left: -1.2rem;
    box-sizing: border-box;
    border-color: #ad6726;
    border-width: 0.2rem;
    width: 1.1rem;
    height: 0.7rem;
    border-right: 0;
    border-top: 0;
    transform: rotate(-55deg);
  }

  /*
  ===========================================================
      RadioButton
  ===========================================================
  */
  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div > label > input {
    width: ${props => (props.$escomputadora ? "0.8rem" : "1.7rem")};
  }

  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div {
    background-color: white;
    box-sizing: border-box;
    border-radius: ${props => (props.$escomputadora ? "0.35rem" : "0.7rem")};
    align-items: center;
    justify-content: center;
    border: var(--elemento-border);
    padding-bottom: 0.5rem;
    height: 100%;
  }

  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div > span {
    display: block;
    background-color: var(--cabecera-elemento-background-color);
    font-size: var(--cabecera-elemento-font-size);
    color: var(--cabecera-elemento-color);
    padding-left: ${props => (props.$escomputadora ? "0.7rem" : "1rem")};
  }

  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div > label {
    display: flex;
    align-items: center;
    height: ${props => (props.$escomputadora ? "1.5rem" : "2.5rem")};
  }
  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div > label > span {
    font-size: var(--contenido-elemento-font-size);
    font-weight: var(--contenido-elemento-font-weight);
    display: flex;
    align-items: center;
  }
  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div > label > input[type="radio"] {
    display: none;
  }
  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div > label > input[type="radio"] + span:before {
    content: "";
    width: ${props => (props.$escomputadora ? "1rem" : "2rem")};
    height: ${props => (props.$escomputadora ? "1rem" : "2rem")};
    background-color: #ffffff;
    display: flex;
    border-radius: 100%;
    border: 0.1rem solid rgb(173, 173, 173);
    margin: 0.5rem;
    box-sizing: border-box;
  }
  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div > label > input[type="radio"]:checked + span:before {
    content: "";
    background-color: #ad6726;
    display: flex;
  }

  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div > label > input[type="radio"]:checked + span {
    background-color:rgb(238, 222, 193);
    width: 100%;
    border-radius: 1rem;
    height: 100%;
  }

  /*
  ===========================================================
      OPTION
  ===========================================================
  */
  .formulariotemplate > .elementostemplate > .OptionForm > div {
    background-color: white;
    box-sizing: border-box;
    height: 100%;
    border-radius: ${props => (props.$escomputadora ? "0.35rem" : "0.7rem")};
    align-items: center;
    justify-content: center;
    border: var(--elemento-border);
    padding-bottom: 0.5rem;
  }

  .formulariotemplate > .elementostemplate > .OptionForm > div > label {
    display: block;
    background-color: var(--cabecera-elemento-background-color);
    font-size: var(--cabecera-elemento-font-size);
    color: var(--cabecera-elemento-color);
    padding-left: ${props => (props.$escomputadora ? "0.7rem" : "1rem")};
  }

  .formulariotemplate > .elementostemplate > .OptionForm > div > select {
    box-sizing: border-box;
    background-color: white;
    display: flex;
    margin-left: 5%;
    margin-top: 0.5rem;
    outline: none;
    width: 90%;
    font-size: var(--contenido-elemento-font-size);
    font-weight: var(--contenido-elemento-font-weight);
    border-radius: 1rem;
    border-color: #cccccc;
  }

  /*
  ===========================================================
      DATE
  ===========================================================
  */

  .formulariotemplate > .elementostemplate > .DateForm > div {
    background-color: white;
    box-sizing: border-box;
    height: 100%;
    border-radius: 0.35rem;
    align-items: center;
    justify-content: center;
    border: var(--elemento-border);
    padding-bottom: 0.5rem;
  }

  .formulariotemplate > .elementostemplate > .DateForm > div > label {
    display: block;
    background-color: var(--cabecera-elemento-background-color);
    font-size: 1rem;
    color: rgb(82, 82, 82);
    padding-left: 0.7rem;
  }

  .formulariotemplate > .elementostemplate > .DateForm > div > input {
    box-sizing: border-box;
    background-color: white;
    display: flex;
    margin-left: 5%;
    margin-top: 0.5rem;
    outline: none;
    width: 90%;
    font-size: var(--contenido-elemento-font-size);
    font-weight: var(--contenido-elemento-font-weight);
    border-radius: 1rem;
    border-color: #cccccc;
    border: var(--elemento-border);
    position: relative;
  }

  .formulariotemplate > .elementostemplate > .DateForm > div > input[type="date"]::-webkit-calendar-picker-indicator {
    display: flex;
    position: absolute;
    width: 0.8rem;
    height: 0.8rem;
    right:0.8rem;
  }

  /*
  ===========================================================
      DESHABILITADOS
  ===========================================================
  */

  .formulariotemplate > .elementostemplate > .InputForm > input:disabled,
  .formulariotemplate > .elementostemplate > .CheckboxForm > div:has(> label > input[type="checkbox"]:disabled),
  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div:has(> label > input[type="radio"]:disabled),
  .formulariotemplate > .elementostemplate > .OptionForm > div > select:disabled,
  .formulariotemplate > .elementostemplate > .OptionForm > div:has(> select:disabled),
  .formulariotemplate > .elementostemplate > .DateForm > div:has(> input[type="date"]:disabled),
  .formulariotemplate > .elementostemplate > .DateForm > div > input[type="date"]:disabled {
    background-color: rgb(194, 194, 194);
    color: rgb(110, 110, 110);
    border-color: rgb(110, 110, 110);
  }

  .formulariotemplate > .elementostemplate > .CheckboxForm > div > label > input[type="checkbox"]:disabled:checked + span::after {
    border-color: rgb(119, 119, 119);
  }

  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div > label > input[type="radio"]:disabled + span:before {
    background-color: rgb(228, 228, 228);
    border: 0.1rem solid rgb(199, 199, 199);
  }
  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div > label > input[type="radio"]:disabled:checked + span:before {
    background-color: rgb(119, 119, 119);
  }

  .formulariotemplate > .elementostemplate > .RadiobuttonForm > div > label > input[type="radio"]:disabled:checked + span {
    background-color: rgb(201, 201, 201);
  }

  .formulariotemplate > .elementostemplate > .InputForm > input:focus, 
  .formulariotemplate > .elementostemplate > .InputForm > input:hover,
  .CheckboxForm > div:hover,
  .OptionForm > div:hover,
  .DateForm > div:hover,
  .RadiobuttonForm > div:hover {
    ${props => (!props.$escomputadora && css`border: green 0.1rem solid !important; `)}
    box-shadow:0 0 0.2rem green inset;
  }
`;
